module.exports = "/images/dylan.jpg?3a012a29ed29e6dc99accd58ffe3809e";